import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { AddShopMemberWithTokenDto } from "../generated/schema";

export default function useAddShopMemberWithToken({
  onSuccess,
}: {
  onSuccess?: (data: unknown, variables: { shopId: string }) => void;
}) {
  const mutation = $api.useMutation("post", "/public/shops/{shopId}/members/token");

  return useMutation({
    onSuccess: onSuccess,
    onError: () => {},
    mutationFn: async ({
      shopId,
      data,
    }: {
      shopId: string;
      data: AddShopMemberWithTokenDto;
    }) => {
      return mutation.mutateAsync({
        params: { path: { shopId } },
        body: data,
      });
    },
  });
}
